import React, { useState } from "react";
import { Link } from "react-router-dom";
import CreateListingForm from "./listing/CreateListingForm";

function MarketHome() {
  const [showCreateForm, setShowCreateForm] = useState(false);
  return (
    <div className="market-home">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <div className="hero-badge">
            <span>🏆</span>
            <span>Nền tảng mua bán hàng đầu Việt Nam</span>
          </div>
          <h1 className="hero-title">
            Chào mừng đến với 
            <span className="brand-highlight"> timquanhday</span>
          </h1>
          <p className="hero-subtitle">
            Nơi kết nối người mua và người bán một cách an toàn, nhanh chóng và tiện lợi. 
            Khám phá hàng ngàn sản phẩm chất lượng với giá tốt nhất.
          </p>
          <div className="hero-actions">
            <Link to="/market/thanh-ly" className="btn-primary">
              <span className="btn-icon">🛒</span>
              <span>Khám phá sản phẩm</span>
            </Link>
            <button onClick={() => setShowCreateForm(true)} className="btn-secondary">
              <span className="btn-icon">📝</span>
              <span>Đăng tin bán hàng</span>
            </button>
          </div>
        </div>
        <div className="hero-visual">
          <div className="floating-card card-1">
            <div className="card-icon">📱</div>
            <div className="card-text">Điện thoại</div>
          </div>
          <div className="floating-card card-2">
            <div className="card-icon">💻</div>
            <div className="card-text">Laptop</div>
          </div>
          <div className="floating-card card-3">
            <div className="card-icon">🚗</div>
            <div className="card-text">Xe cộ</div>
          </div>
          <div className="floating-card card-4">
            <div className="card-icon">🏠</div>
            <div className="card-text">Nhà đất</div>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">50K+</div>
              <div className="stat-label">Sản phẩm</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">10K+</div>
              <div className="stat-label">Người dùng</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">99%</div>
              <div className="stat-label">Hài lòng</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Hỗ trợ</div>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="features-section">
        <div className="container">
          <div className="section-header">
            <h2>Tại sao chọn timquanhday?</h2>
            <p>Chúng tôi cam kết mang đến trải nghiệm mua bán tốt nhất</p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <div className="icon-bg">🛡️</div>
              </div>
              <h3>An toàn tuyệt đối</h3>
              <p>Hệ thống bảo mật cao, xác thực người dùng và giao dịch an toàn</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <div className="icon-bg">⚡</div>
              </div>
              <h3>Nhanh chóng</h3>
              <p>Tìm kiếm và kết nối ngay lập tức với người bán gần bạn</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <div className="icon-bg">💰</div>
              </div>
              <h3>Giá tốt nhất</h3>
              <p>So sánh giá từ nhiều người bán để tìm được deal tốt nhất</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <div className="icon-bg">🎯</div>
              </div>
              <h3>Chính xác</h3>
              <p>Tìm kiếm thông minh giúp bạn tìm đúng sản phẩm cần</p>
            </div>
          </div>
        </div>
      </div>

      {/* Categories Preview */}
      <div className="categories-section">
        <div className="container">
          <div className="section-header">
            <h2>Danh mục phổ biến</h2>
            <p>Khám phá các sản phẩm theo danh mục</p>
          </div>
          <div className="categories-grid">
            <Link to="/market/thanh-ly/1" className="category-card">
              <div className="category-icon">📱</div>
              <h3>Điện tử</h3>
              <p>Điện thoại, laptop, phụ kiện</p>
            </Link>
            <Link to="/market/thanh-ly/2" className="category-card">
              <div className="category-icon">👕</div>
              <h3>Thời trang</h3>
              <p>Quần áo, giày dép, phụ kiện</p>
            </Link>
            <Link to="/market/thanh-ly/3" className="category-card">
              <div className="category-icon">🏠</div>
              <h3>Nhà cửa</h3>
              <p>Nội thất, đồ gia dụng</p>
            </Link>
            <Link to="/market/thanh-ly/4" className="category-card">
              <div className="category-icon">🚗</div>
              <h3>Xe cộ</h3>
              <p>Ô tô, xe máy, phụ tùng</p>
            </Link>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Sẵn sàng bắt đầu?</h2>
            <p>Tham gia cộng đồng mua bán lớn nhất Việt Nam</p>
            <div className="cta-actions">
              <Link to="/market/thanh-ly" className="btn-primary large">
                <span className="btn-icon">🔍</span>
                <span>Tìm kiếm sản phẩm</span>
              </Link>
              <button onClick={() => setShowCreateForm(true)} className="btn-secondary large">
                <span className="btn-icon">📝</span>
                <span>Đăng tin miễn phí</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal đăng tin sản phẩm */}
      {showCreateForm && (
        <div className="modal-overlay" onClick={() => setShowCreateForm(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Đăng tin sản phẩm</h2>
              <button 
                className="close-btn" 
                onClick={() => setShowCreateForm(false)}
                aria-label="Đóng"
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <CreateListingForm onSuccess={() => setShowCreateForm(false)} />
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .market-home {
          min-height: calc(100vh - 60px);
          background-color: #0f172a;
          color: #e5e7eb;
          padding-top: 0;
        }
        
        .hero-section {
          background: linear-gradient(135deg, #1e293b 0%, #334155 50%, #475569 100%);
          padding: 80px 20px 120px;
          position: relative;
          overflow: hidden;
        }
        
        .hero-content {
          max-width: 1200px;
          margin: 0 auto;
          text-align: center;
          position: relative;
          z-index: 2;
        }
        
        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(74, 222, 128, 0.1);
          border: 1px solid rgba(74, 222, 128, 0.3);
          border-radius: 50px;
          padding: 8px 16px;
          margin-bottom: 24px;
          font-size: 14px;
          color: #86efac;
        }
        
        .hero-title {
          font-size: 4rem;
          font-weight: 800;
          margin-bottom: 24px;
          color: #f1f5f9;
          line-height: 1.1;
        }
        
        .brand-highlight {
          background: linear-gradient(135deg, #4ade80, #22c55e);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        .hero-subtitle {
          font-size: 1.25rem;
          color: #cbd5e1;
          margin-bottom: 40px;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
          line-height: 1.6;
        }
        
        .hero-actions {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        
        .btn-primary, .btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 16px 32px;
          border-radius: 12px;
          text-decoration: none;
          font-weight: 600;
          font-size: 16px;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          border: none;
          cursor: pointer;
        }
        
        .btn-primary {
          background: linear-gradient(135deg, #4ade80, #22c55e);
          color: #0f172a;
          box-shadow: 0 4px 15px rgba(74, 222, 128, 0.3);
        }
        
        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(74, 222, 128, 0.4);
        }
        
        .btn-secondary {
          background: transparent;
          color: #4ade80;
          border: 2px solid #4ade80;
        }
        
        .btn-secondary:hover {
          background: #4ade80;
          color: #0f172a;
          transform: translateY(-2px);
        }
        
        .hero-visual {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
        }
        
        .floating-card {
          position: absolute;
          background: rgba(30, 41, 59, 0.8);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(74, 222, 128, 0.2);
          border-radius: 16px;
          padding: 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          animation: float 6s ease-in-out infinite;
        }
        
        .card-1 { top: 20%; left: 10%; animation-delay: 0s; }
        .card-2 { top: 30%; right: 15%; animation-delay: 1.5s; }
        .card-3 { bottom: 30%; left: 20%; animation-delay: 3s; }
        .card-4 { bottom: 20%; right: 10%; animation-delay: 4.5s; }
        
        .card-icon {
          font-size: 2rem;
        }
        
        .card-text {
          font-size: 12px;
          color: #cbd5e1;
          font-weight: 500;
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        
        .stats-section {
          background: #1e293b;
          padding: 60px 20px;
        }
        
        .container {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 40px;
        }
        
        .stat-item {
          text-align: center;
        }
        
        .stat-number {
          font-size: 3rem;
          font-weight: 800;
          color: #4ade80;
          margin-bottom: 8px;
        }
        
        .stat-label {
          font-size: 1.125rem;
          color: #cbd5e1;
        }
        
        .features-section {
          padding: 80px 20px;
        }
        
        .section-header {
          text-align: center;
          margin-bottom: 60px;
        }
        
        .section-header h2 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #f1f5f9;
          margin-bottom: 16px;
        }
        
        .section-header p {
          font-size: 1.125rem;
          color: #cbd5e1;
        }
        
        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 32px;
        }
        
        .feature-card {
          background: #1e293b;
          padding: 40px 32px;
          border-radius: 20px;
          border: 1px solid #334155;
          text-align: center;
          transition: all 0.3s ease;
        }
        
        .feature-card:hover {
          transform: translateY(-8px);
          border-color: #4ade80;
          box-shadow: 0 20px 40px rgba(74, 222, 128, 0.1);
        }
        
        .feature-icon {
          margin-bottom: 24px;
        }
        
        .icon-bg {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #4ade80, #22c55e);
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          margin: 0 auto;
        }
        
        .feature-card h3 {
          font-size: 1.5rem;
          font-weight: 600;
          color: #f1f5f9;
          margin-bottom: 16px;
        }
        
        .feature-card p {
          color: #cbd5e1;
          line-height: 1.6;
        }
        
        .categories-section {
          background: #0f172a;
          padding: 80px 20px;
        }
        
        .categories-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 24px;
        }
        
        .category-card {
          background: #1e293b;
          padding: 32px 24px;
          border-radius: 16px;
          text-align: center;
          text-decoration: none;
          color: inherit;
          border: 1px solid #334155;
          transition: all 0.3s ease;
        }
        
        .category-card:hover {
          transform: translateY(-4px);
          border-color: #4ade80;
          box-shadow: 0 12px 24px rgba(74, 222, 128, 0.15);
        }
        
        .category-icon {
          font-size: 3rem;
          margin-bottom: 16px;
        }
        
        .category-card h3 {
          font-size: 1.25rem;
          font-weight: 600;
          color: #f1f5f9;
          margin-bottom: 8px;
        }
        
        .category-card p {
          color: #cbd5e1;
          font-size: 14px;
        }
        
        .cta-section {
          background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
          padding: 80px 20px;
        }
        
        .cta-content {
          text-align: center;
          max-width: 600px;
          margin: 0 auto;
        }
        
        .cta-content h2 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #f1f5f9;
          margin-bottom: 16px;
        }
        
        .cta-content p {
          font-size: 1.125rem;
          color: #cbd5e1;
          margin-bottom: 40px;
        }
        
        .cta-actions {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        
        .btn-primary.large, .btn-secondary.large {
          padding: 20px 40px;
          font-size: 18px;
        }
        
        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          backdrop-filter: blur(4px);
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }
        
        .modal-content {
          background: #1e293b;
          border-radius: 20px;
          border: 1px solid #334155;
          max-width: 800px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
        }
        
        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 24px 32px;
          border-bottom: 1px solid #334155;
        }
        
        .modal-header h2 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #f1f5f9;
          margin: 0;
        }
        
        .close-btn {
          background: transparent;
          border: none;
          color: #cbd5e1;
          font-size: 1.5rem;
          cursor: pointer;
          padding: 8px;
          border-radius: 8px;
          transition: all 0.2s;
        }
        
        .close-btn:hover {
          background: #334155;
          color: #f1f5f9;
        }
        
        .modal-body {
          padding: 32px;
        }
        
        @media (max-width: 768px) {
          .hero-title {
            font-size: 2.5rem;
          }
          
          .hero-actions {
            flex-direction: column;
            align-items: center;
          }
          
          .btn-primary, .btn-secondary {
            width: 100%;
            max-width: 300px;
            justify-content: center;
          }
          
          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 24px;
          }
          
          .features-grid {
            grid-template-columns: 1fr;
          }
          
          .categories-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .cta-actions {
            flex-direction: column;
            align-items: center;
          }
          
          .btn-primary.large, .btn-secondary.large {
            width: 100%;
            max-width: 300px;
          }
        }
      `}</style>
    </div>
  );
}

export default MarketHome;
